import { render } from "./VendorRankingTitle012.vue?vue&type=template&id=5d623587&scoped=true"
import script from "./VendorRankingTitle012.vue?vue&type=script&lang=js"
export * from "./VendorRankingTitle012.vue?vue&type=script&lang=js"

import "./VendorRankingTitle012.vue?vue&type=style&index=0&id=5d623587&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d623587"]])

export default __exports__